/**
 * This set of configuration options is based on several open source gists (https://gist.github.com/Chocksy/e9b2cdd4afc2aadc7989762c4b8b495a).
 * It filters out common sources of noise in browser-based errors like browser extensions. We can add to it as we see
 * new types of errors that are not controled by our source code or the third-party scripts we intentionally include on
 * each page.
 */
export default {
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Avast extension error
    '_avast_submit',
    // Vendor globals that GTM tags or injected scripts call; they throw when the script is blocked or missing. See DEV-159794.
    /\b(fbq|braze|googletag|eventTracker|_omlfp) is not defined/,
    /\bclarity is not a function/,
    // GTM Custom HTML tags running without the container runtime (container id 354917). See DEV-159795.
    /google_tag_manager\.rm\./,
    "reading '354917'",
    // Scripts injected by iOS browsers (Brave, Firefox) and extensions (wallets, Amplitude, a Safari extension)
    '__firefox__',
    'window.ethereum',
    'amp_injected_session_replay',
    'webkitExitFullScreen',
    // Facebook and Instagram in-app browsers on iOS inject a script that reads window._META. See SSR-9N.
    'IABInnerFrame',
    /user:action \w+ not found/,
    // Scraper bots: an inline script that throws, and a promise that rejects with a bare string
    'serviceName is not defined.',
    'Non-Error promise rejection captured with value: invalid_request',
    // WebKit IndexedDB bug on resumed tabs. Amplitude Session Replay (withAmplitude.ts) uses
    // IndexedDB, but the failure is inside WebKit, not in our calls.
    'An internal error was encountered in the Indexed Database server',
  ],
  denyUrls: [
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Browser extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // @sentry/nextjs rewrites frame origins to app:/// after this filter runs, so Sentry's
    // server-side extension filter can't match ssr-rover events. See SSR-ROVER-106Q.
    /^(chrome|moz|safari(-web)?)-extension:\/\//i,
    /webkit-masked-url/i,
    /:\/\/hidden\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Remark shopping widget, injected by scrapers
    /\.withremark\.com\//i,
    // Third-party scripts injected by scrapers: Immedio SDK, a Mudi 3D viewer, Alright Network tags
    /sdk\.immedio\.io\//i,
    /viewer\.mudi\.com\.co\//i,
    /tagmanager\.alright\.network\//i,
    // OneTrust's consent stub failing to parse a response. Our pages use Ketch and never load
    // OneTrust themselves. See SSR-1399.
    /cdn\.cookielaw\.org\//i,
  ],
};
